'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoEject = function IoEject(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.2 25h-22.4c-0.8 0-1.3-0.5-1.3-1.2 0-0.3 0.1-0.4 0.2-0.7l10.8-14.9c0.4-0.4 0.9-0.7 1.5-0.7s1.1 0.3 1.5 0.7l10.8 14.8c0.1 0.3 0.2 0.5 0.2 0.7 0 0.8-0.6 1.3-1.3 1.3z m0.4 2.5c0.5 0 0.9 0.4 0.9 0.9v3.2c0 0.5-0.4 0.9-0.9 0.9h-23.2c-0.5 0-0.9-0.4-0.9-0.9v-3.2c0-0.5 0.4-0.9 0.9-0.9h23.2z' })
        )
    );
};

exports.default = IoEject;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/eject.js
// module id = 2044
// module chunks = 0